import {
    PayLaterLinkedMetaPoint,
    PayLaterLinkedData,
    PayLaterPaymentMethodData,
} from "@payment-ui/interfaces/PayLater";
import { getIconCloudinaryUrl as getCloudinaryUrl } from "@payment-ui/helpers/Icon";
import { PAYLATER_TYPES } from "@swiggy-private/payment-core";

export const isAmazonPayLater = (paymentCode: string): boolean =>
    paymentCode?.toUpperCase() === PAYLATER_TYPES.AMAZON_PAYLATER?.toUpperCase();

export const getPayLaterLinkedMetaText = (payLaterLinkedData: PayLaterLinkedData): string =>
    payLaterLinkedData.meta?.text ?? "";

export const getPayLaterMetaPointIconUrl = (point: PayLaterLinkedMetaPoint): string =>
    point.iconUrl != null ? getCloudinaryUrl(point.iconUrl, { trim: true }) : "";

export const getPayLaterMetaPointText = (point: PayLaterLinkedMetaPoint): string => point.text ?? "";

export const getPayLaterMetaPoints = (payLaterLinkedData: PayLaterLinkedData): PayLaterLinkedMetaPoint[] =>
    payLaterLinkedData.meta?.points ?? [];

export const getTNCUrl = (paymentMethod: PayLaterPaymentMethodData): string | undefined => paymentMethod.meta["t&cUrl"];

export const getPaymentDueDateMessage = (paymentMethod: PayLaterPaymentMethodData): string =>
    paymentMethod.meta.dueDateMessage ?? "";
